"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomViewport = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var AsyncDebounce_1 = require("icf-search-client-shared/lib/AsyncDebounce");
var EqualityComparers_1 = require("icf-search-client-shared/lib/EqualityComparers");
var Observable_1 = require("icf-search-client-shared/lib/observables/Observable");
var Profiler_1 = require("icf-search-client-shared/lib/Profiler");
var Utilities_1 = require("icf-search-client-shared/lib/Utilities");
// Test coverage extremely prohibitive since jsdom doesn't support getBoundingClientRect
var DomViewport = /** @class */ (function () {
    /**
     * Creates an instance of DomViewport.
     */
    /* istanbul ignore next */
    function DomViewport(element) {
        var _this = this;
        this._triggerUpdate = function () {
            _this._updateDebounce.execute(_this._updateVisibleRect);
        };
        /* istanbul ignore next */
        this._updateVisibleRect = function () {
            // TODO: Overflow scrolling element support
            var windowWidth = window.innerWidth;
            var windowHeight = window.innerHeight;
            Profiler_1.profiler.measure(function () {
                var rect = Profiler_1.profiler.measure(function () { return _this._element.getBoundingClientRect(); }, "DomViewport._updateVisibleRect-getBoundingClientRect");
                _this._visibleRect.value = {
                    x: -rect.left,
                    y: -rect.top,
                    width: windowWidth,
                    height: windowHeight,
                };
            }, "DomViewport._updateVisibleRect");
        };
        this._element = element;
        this._updateDebounce = new AsyncDebounce_1.AsyncDebounce(100);
        this._visibleRect = new Observable_1.Observable({
            x: 0,
            y: 0,
            width: 0,
            height: 0,
        }, EqualityComparers_1.rectEqualityComparer);
        this._updateVisibleRect();
        this._scrollSubscription = (0, Utilities_1.subscribeToEvent)(window, function (ael) { return ael("scroll", _this._triggerUpdate, true); });
        this._windowResizeSubscription = (0, Utilities_1.subscribeToEvent)(window, function (ael) { return ael("resize", _this._triggerUpdate, true); });
        // Force updates periodically without user action for when page potentially reflows.
        this._updateInterval = (0, Utilities_1.createInterval)(this._triggerUpdate, 500);
    }
    Object.defineProperty(DomViewport.prototype, "visibleRect", {
        /* istanbul ignore next */
        get: function () {
            /* istanbul ignore next */
            return this._visibleRect.asReadonly();
        },
        enumerable: false,
        configurable: true
    });
    /* istanbul ignore next */
    DomViewport.prototype.dispose = function () {
        this._updateInterval.dispose();
        this._windowResizeSubscription.dispose();
        this._scrollSubscription.dispose();
        this._updateDebounce.dispose();
    };
    return DomViewport;
}());
exports.DomViewport = DomViewport;
//# sourceMappingURL=DomViewport.js.map